import { Inject, Injectable } from '@angular/core';
import { API_ENDPOINTS, ApiEndpoints, ApiResponse } from '@contracts';
import { ApiCilent, ModuleRequestHelper } from '@core';
import { Observable } from 'rxjs';
import { ReportList, ReportQuery } from '../types/report.type';

@Injectable({ providedIn: 'root' })
export class ReportService {
  constructor(
    private readonly apiClient: ApiCilent,
    private readonly moduleHelper: ModuleRequestHelper,
    @Inject(API_ENDPOINTS) private readonly endpoints: ApiEndpoints,
  ) {}

  getReport(query?: ReportQuery): Observable<ApiResponse<ReportList>> {
    const endpoint = this.endpoints.report.list;
    return this.apiClient.get<ApiResponse<ReportList>>({
      path: endpoint.path,
      domain: endpoint.domain,
      version: endpoint.version,
      query: this.moduleHelper.withModuleQuery(query),
    });
  }
}
